// extracted by mini-css-extract-plugin
export default {"circle":"AvatarProfile_circle__Bf2Uf","middle":"AvatarProfile_middle__yj2vo","inner":"AvatarProfile_inner__i-Tv9","faceIcon":"AvatarProfile_faceIcon__yqkR4"};